import { render, staticRenderFns } from "./MarzipanoRectConfigurator.vue?vue&type=template&id=0063d716&scoped=true&"
import script from "./MarzipanoRectConfigurator.vue?vue&type=script&lang=js&"
export * from "./MarzipanoRectConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./MarzipanoRectConfigurator.vue?vue&type=style&index=0&id=0063d716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063d716",
  null
  
)

export default component.exports